import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import { alphabetsData } from '../data/alphabets';
import { useSpeech } from '../hooks/useSpeech';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import './AlphabetDetail.css';

const AlphabetDetail = () => {
    const { letter } = useParams();
    const history = useHistory();
    const { speak } = useSpeech();

    const itemIndex = alphabetsData.findIndex(i => i.letter === letter);
    const item = alphabetsData[itemIndex];

    useEffect(() => {
        if (item) {
            // slight delay to allow transition
            const timer = setTimeout(() => {
                speak(`${item.letter} is for ${item.word}`, { rate: 0.7 });
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [item, speak]);

    if (!item) return <Layout title="Error">Letter not found</Layout>;

    const handleNext = () => {
        const nextIndex = (itemIndex + 1) % alphabetsData.length;
        history.push(`/alphabets/${alphabetsData[nextIndex].letter}`);
    };

    const handlePrev = () => {
        const prevIndex = (itemIndex - 1 + alphabetsData.length) % alphabetsData.length;
        history.push(`/alphabets/${alphabetsData[prevIndex].letter}`);
    };

    return (
        <Layout title={`Letter ${item.letter}`} onBack={() => history.push('/alphabets')}>
            <div key={letter} className="alphabet-detail-container" style={{ backgroundColor: item.color }}>
                <div className="detail-card">
                    <div className="detail-letter">{item.letter}</div>
                    <div className="detail-emoji">{item.emoji}</div>
                    <div className="detail-word">{item.word}</div>
                    <button className="speak-button" onClick={() => speak(item.word, { rate: 0.7 })}>🔊 Speak</button>
                </div>

                <div className="detail-controls">
                    <button className="nav-arrow" onClick={handlePrev}><ArrowLeft size={32} /></button>
                    <button className="nav-arrow" onClick={handleNext}><ArrowRight size={32} /></button>
                </div>
            </div>
        </Layout>
    );
};

export default AlphabetDetail;
